"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("rxjs/add/operator/first");
require("rxjs/add/operator/finally");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var nav_bar_item_model_1 = require("../modules/navigation/nav-bar/nav-bar-item.model");
var idm_page_service_client_js_1 = require("@synisys/idm-page-service-client-js");
var nav_bar_type_1 = require("../modules/navigation/nav-bar/nav-bar-type");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var http_1 = require("@angular/common/http");
var navigation_message_service_1 = require("./navigation-message-service");
var config_1 = require("../config");
/**
 * Http implementation to loading navigation items
 */
var HttpNavigationService = /** @class */ (function () {
    function HttpNavigationService(http, authorizationService, authenticationService, pageNavigationService, navigationMessageService, coreConfigPath) {
        this.http = http;
        this.authorizationService = authorizationService;
        this.authenticationService = authenticationService;
        this.pageNavigationService = pageNavigationService;
        this.navigationMessageService = navigationMessageService;
        this.coreConfigPath = coreConfigPath;
        this.navigationItems = new ReplaySubject_1.ReplaySubject(1);
    }
    HttpNavigationService_1 = HttpNavigationService;
    /**
     * Filter navigation items by user permission
     * @returns Array of filtered navigation items
     */
    HttpNavigationService.prototype.getNavigationItems = function () {
        var _this = this;
        var userDataPromise = this.authenticationService
            .getUserData()
            .first()
            .toPromise();
        var navigationItemsPromise = this.navigationItems.toPromise();
        return Promise.all([navigationItemsPromise, userDataPromise]).then(function (_a) {
            var navItems = _a[0], userData = _a[1];
            return _this.getGrantedNavItems(navItems, userData.userId).toPromise();
        });
    };
    /**
     * loads all Navigation items by merging page service nav items and config file nav items(full or core) and puts into ReplaySubject
     */
    HttpNavigationService.prototype.loadNavigationItems = function (navConfigFileUri) {
        var _this = this;
        return Promise.all([
            this.getPageNavigationItems(),
            this.getPersonalNavigationItems(),
            this.getConfigNavigationItems(navConfigFileUri)
        ])
            .then(function (_a) {
            var pageNavItems = _a[0], personalPages = _a[1], configNavItems = _a[2];
            _this.navigationItems.next(pageNavItems.concat(personalPages).concat(configNavItems));
            _this.navigationItems.complete();
        })
            .catch(this.handleError);
    };
    /**
     * Get navigation items from page service.
     */
    HttpNavigationService.prototype.getPageNavigationItems = function () {
        var _this = this;
        return this.pageNavigationService
            .getNavigation()
            .then(function (response) {
            if (!Boolean(response.length)) {
                return [];
            }
            var section = new nav_bar_item_model_1.NavigationItem('', '', '', [], false, false, false, false, nav_bar_type_1.NavBarType.SECTION, _this.convertPageItemsToNavigationItems(response));
            return [section];
        })
            .catch(function (reason) {
            _this.handleError(reason);
            return Promise.resolve([]);
        });
    };
    /**
     * Get personal navigation items (my pages) from page service.
     */
    HttpNavigationService.prototype.getPersonalNavigationItems = function () {
        var _this = this;
        return this.pageNavigationService.getPersonalNavigation().then(function (personalPages) {
            var newPageItem = new nav_bar_item_model_1.NavigationItem('', 'nav.bar.myPages.newPage', '/pages/new', [HttpNavigationService_1.PERSONAL_PAGES_PERMISSION_KEY], true, false, false, false, nav_bar_type_1.NavBarType.ITEM, []);
            var personalNavigationItems = _this.handlePersonalNavigationItems(_this.convertPageItemsToNavigationItems(personalPages, true));
            var group = new nav_bar_item_model_1.NavigationItem('my_pages', 'nav.bar.myPages', '/personal-pages', [HttpNavigationService_1.PERSONAL_PAGES_PERMISSION_KEY], true, false, true, false, nav_bar_type_1.NavBarType.GROUP, personalNavigationItems); // TODO concat newPageItem
            var section = new nav_bar_item_model_1.NavigationItem('', '', '', [HttpNavigationService_1.PERSONAL_PAGES_PERMISSION_KEY], false, false, false, false, nav_bar_type_1.NavBarType.SECTION, [group]);
            return [section];
        });
    };
    /**
     * Get config navigation items from config file, if there is a full config file for nav
     * items (which means core navigation items has been provided too) then read items from that file
     * otherwise return only core navigation items.
     */
    HttpNavigationService.prototype.getConfigNavigationItems = function (navConfigFileUri) {
        var _this = this;
        var coreNavigationItems = this.getCoreNavigationItems();
        var configNavigationItems = this.http
            .get(navConfigFileUri)
            .toPromise()
            .then(function (response) {
            return _this.extractNavigationItemsFromResponse(response);
        })
            .catch(function () { return []; });
        return Promise.all([coreNavigationItems, configNavigationItems]).then(function (_a) {
            var coreItems = _a[0], configItems = _a[1];
            return _this.mergeNavigationItems(configItems, coreItems);
        });
    };
    /**
     * Merge second array to first recursively, but don't override.
     * @param baseNavItems
     * @param navItemsToMerge
     */
    HttpNavigationService.prototype.mergeNavigationItems = function (baseNavItems, navItemsToMerge) {
        var _this = this;
        var mergedItems = baseNavItems.slice();
        var baseItemsByTitleKeys = new Map();
        baseNavItems.forEach(function (item) {
            baseItemsByTitleKeys.set(item.titleKey, item);
        });
        navItemsToMerge.forEach(function (itemToMerge) {
            var _a;
            var baseItem = baseItemsByTitleKeys.get(itemToMerge.titleKey);
            if (baseItem) {
                if (itemToMerge.navBarType === baseItem.navBarType && itemToMerge.navBarType !== nav_bar_type_1.NavBarType.ITEM) {
                    // groups and sections with same title keys
                    var mergedChildren = _this.mergeNavigationItems(baseItem.children, itemToMerge.children);
                    (_a = baseItem.children).splice.apply(_a, [0, baseItem.children.length].concat(mergedChildren)); // override children with merged items
                }
            }
            else {
                mergedItems.push(itemToMerge);
            }
        });
        return mergedItems;
    };
    /**
     * Get core navigation items from config file.
     */
    HttpNavigationService.prototype.getCoreNavigationItems = function () {
        var _this = this;
        if (!this.coreConfigPath) {
            console.error('Core navigation config path has not been specified');
            return Promise.resolve([]);
        }
        var coreNavConfigUrl = this.coreConfigPath + "/" + HttpNavigationService_1.CORE_NAV_CONFIG_FILE_NAME;
        return this.http
            .get(coreNavConfigUrl)
            .toPromise()
            .then(function (response) {
            return _this.extractNavigationItemsFromResponse(response);
        })
            .catch(function (reason) {
            console.error("Core navigation config file not found in path " + coreNavConfigUrl);
            return [];
        });
    };
    /**
     * Convert page navigation items to plain Navigation items
     * @param pageItems Array of navigation items
     */
    HttpNavigationService.prototype.convertPageItemsToNavigationItems = function (pageItems, isPersonalPage) {
        var _this = this;
        if (isPersonalPage === void 0) { isPersonalPage = false; }
        return pageItems.map(function (pageItem) { return _this.convertPageItemToNavigationItem(pageItem, isPersonalPage); });
    };
    /**
     * Convert page navigation item to plain Navigation item with title-key generation
     * @param pageItem converted navigation item
     */
    HttpNavigationService.prototype.convertPageItemToNavigationItem = function (pageItem, isPersonalPage) {
        if (isPersonalPage === void 0) { isPersonalPage = false; }
        var icon = pageItem.icon;
        var routLink = isPersonalPage ? pageItem.routLink : '/pages/' + pageItem.routLink;
        var titleKey = navigation_message_service_1.NavigationMessageService.NAV_BAR_TITLE_PREFIX + routLink.replace(/\//g, '.');
        var permissionKey = pageItem.permissionKey;
        var navBarType = pageItem.navBarType === 'GROUP' ? nav_bar_type_1.NavBarType.GROUP : nav_bar_type_1.NavBarType.ITEM;
        var isVisible = true;
        var children = pageItem.children === null ? null : this.convertPageItemsToNavigationItems(pageItem.children);
        this.navigationMessageService.put(titleKey, pageItem.title);
        return new nav_bar_item_model_1.NavigationItem(icon, titleKey, routLink, permissionKey, isVisible, false, false, false, navBarType, children);
    };
    /**
     * Map response json parse to Navigation item and add into array
     * @returns Array of navigation items
     */
    HttpNavigationService.prototype.extractNavigationItemsFromResponse = function (res) {
        var _this = this;
        return res.map(function (item) { return _this.extractNavigationItem(item); });
    };
    /**
     * Parse response item to Navigation Item
     * @returns NavigationItem
     */
    HttpNavigationService.prototype.extractNavigationItem = function (item) {
        var icon = item.icon;
        var titleKey = item.titleKey;
        var routLink = item.routLink;
        var permissionKey = item.permissionKey;
        var navBarType = this.getNavBarType(item.navBarType);
        var isVisible = Boolean(item.isVisible);
        var isDefault = Boolean(item.isDefault);
        var isConfigurable = Boolean(item.isConfigurable);
        var isExternal = Boolean(item.isExternal);
        var children = item.children === null ? null : this.extractNavigationItemsFromResponse(item.children);
        return new nav_bar_item_model_1.NavigationItem(icon, titleKey, routLink, permissionKey, isVisible, isDefault, isConfigurable, isExternal, navBarType, children);
    };
    HttpNavigationService.prototype.handlePersonalNavigationItems = function (items) {
        return items.map(function (item) {
            return new nav_bar_item_model_1.NavigationItem(item.icon, item.titleKey, '/personal-pages/' + item.routeLink, item.permissionKey, item.isVisible, item.isDefault, item.isConfigurable, item.isExternal, item.navBarType, item.children);
        });
    };
    /**
     *
     * @param navItems
     * @param currentUserId
     * @returns {Array<NavigationItem>}
     */
    HttpNavigationService.prototype.getGrantedNavItems = function (navItems, currentUserId) {
        var _this = this;
        /**
         * create array with empty elements which size is equal to navItems size
         * for keeping insert(splice) ordering with given index
         */
        var grantedItems = new Array(navItems.length);
        var grantedItems_ = new ReplaySubject_1.ReplaySubject(1);
        var obsList = [];
        navItems.forEach(function (navItem, index) {
            if (navItem.children.length === 0) {
                var hasAccess_1 = false;
                if (navItem.permissionKey && navItem.permissionKey.length > 0) {
                    navItem.permissionKey.some(function (value) {
                        if (hasAccess_1) {
                            return true;
                        }
                        var obs = _this.authorizationService
                            .getPermissionAccessValue(currentUserId, value)
                            .first()
                            .toPromise();
                        obs.then(function (permissionValueDto) {
                            if (permissionValueDto.access === idm_authorization_client_js_1.Access.FULL && !hasAccess_1) {
                                hasAccess_1 = true;
                                grantedItems[index] = new nav_bar_item_model_1.NavigationItem(navItem.icon, navItem.titleKey, navItem.routeLink, navItem.permissionKey, navItem.isVisible, navItem.isDefault, navItem.isConfigurable, navItem.isExternal, navItem.navBarType, []);
                            }
                        });
                        obsList.push(obs);
                    });
                }
                else {
                    grantedItems[index] = new nav_bar_item_model_1.NavigationItem(navItem.icon, navItem.titleKey, navItem.routeLink, navItem.permissionKey, navItem.isVisible, navItem.isDefault, navItem.isConfigurable, navItem.isExternal, navItem.navBarType, []);
                }
            }
            else {
                var obs = _this.getGrantedNavItems(navItem.children, currentUserId)
                    .first()
                    .toPromise();
                obs.then(function (grantedChildren) {
                    if (grantedChildren.length !== 0) {
                        grantedItems[index] = new nav_bar_item_model_1.NavigationItem(navItem.icon, navItem.titleKey, navItem.routeLink, navItem.permissionKey, navItem.isVisible, navItem.isDefault, navItem.isConfigurable, navItem.isExternal, navItem.navBarType, grantedChildren);
                    }
                });
                obsList.push(obs);
            }
        });
        Promise.all(obsList).then(function () {
            /**
             * Push grantedItems where empty values are filtered
             */
            grantedItems_.next(grantedItems.filter(function (x) { return x; }));
            grantedItems_.complete();
        });
        return grantedItems_;
    };
    /**
     *
     * @returns Type of navigation item
     */
    HttpNavigationService.prototype.getNavBarType = function (type) {
        var navBarType;
        switch (type) {
            case 'group':
                navBarType = nav_bar_type_1.NavBarType.GROUP;
                break;
            case 'item':
                navBarType = nav_bar_type_1.NavBarType.ITEM;
                break;
            case 'section':
                navBarType = nav_bar_type_1.NavBarType.SECTION;
                break;
            default:
                throw new Error('Wrong type can not match any Navigation Item type, available types are "group,section,item"');
        }
        return navBarType;
    };
    /**
     * Handle errors
     * @param error
     * @returns {ErrorObservable}
     */
    HttpNavigationService.prototype.handleError = function (error) {
        var errMsg = error.message
            ? error.message
            : error.status
                ? error.status + " - " + error.statusText
                : 'Server error';
        console.error(errMsg);
        return Promise.reject(errMsg);
    };
    var HttpNavigationService_1;
    HttpNavigationService.CORE_NAV_CONFIG_FILE_NAME = 'core-nav-config.json';
    HttpNavigationService.PERSONAL_PAGES_PERMISSION_KEY = '1c96fed1-d48f-475d-86a3-5201517fa910';
    HttpNavigationService = HttpNavigationService_1 = __decorate([
        core_1.Injectable(),
        __param(5, core_1.Optional()), __param(5, core_1.Inject(config_1.Config.coreConfigPathToken)),
        __metadata("design:paramtypes", [http_1.HttpClient,
            idm_authorization_client_js_1.AuthorizationService,
            idm_authentication_client_js_1.AuthenticationService,
            idm_page_service_client_js_1.PageNavigationService,
            navigation_message_service_1.NavigationMessageService, String])
    ], HttpNavigationService);
    return HttpNavigationService;
}());
exports.HttpNavigationService = HttpNavigationService;
//# sourceMappingURL=http-navigation.service.js.map